/*global jQuery*/

import List from 'list.js';
import './index.scss';

jQuery(function(){

    let options = {
        valueNames: [
            'course--title',
            { attr: "data-start-date", name: 'course--start-date' },
            'course--state',
            'course--city',
            'course--status',
        ]
    }

    window.courseCalendar = new List( 'course-calendar', options );

    buildSelect();
    sort();

    jQuery('#search--clear').on('click', function(event)
    {
        event.preventDefault();
        courseCalendar.search();
        courseCalendar.filter();

        jQuery('.search--select select').val('');
        buildSelect();
    });

    jQuery('#course-calendar--mobile-toggle').on('click', function(event)
    {
        event.preventDefault();

        let $searchWrap = jQuery('.course-calendar--search');

        $searchWrap[ $searchWrap.is('.active') ? 'removeClass' : 'addClass' ]('active');
    });


});

const buildSelect = function( ignoreId = false )
{
    let selects = [
        {
            field: 'course--title',
            $select: jQuery('#course-calendar-search-course')
        },
        {
            field: 'course--state',
            $select: jQuery('#course-calendar-search-state')
        },
        {
            field: 'course--city',
            $select: jQuery('#course-calendar-search-city')
        },
        {
            field: 'course--status',
            $select: jQuery('#course-calendar-search-status')
        },
    ];

    selects.forEach((select) => {

        if( ! ignoreId || ( ignoreId !== select.$select.attr('id') ) ) {

            listSelect( select.field, select.$select, courseCalendar ).on('change', function(){

                let selectValues = selects.filter((select) => {
                    return select.$select.val() !== '';
                }).filter(i => i);

                if( ! selectValues.length ) {
                    courseCalendar.filter()
                }else {

                    courseCalendar.filter(function(items) {

                        let multi = [];

                        selects.forEach((select) => {

                            if( select.$select.val() === items.values()[ select.field ] ) {
                                multi.push(true);
                            }
                        });

                        return multi.length == selectValues.length;
                    });
                }

                buildSelect( jQuery(this).attr('id') );
            });
        }
    });
}

const listSelect = function(name, $select, $list)
{
    let selected = $select.val();

    jQuery('option:not(:first)', $select).remove();

    let values = $list.visibleItems.map(function(i){
        return typeof i._values[ name ] !== 'undefined' ? i._values[ name ] : false;
    }).filter( i => i );

    values = values.filter(function(item, pos) {
        return values.indexOf(item) == pos;
    });

    if( values.length ) {
        values.forEach((v) => {
            let $option = jQuery( document.createElement( 'option' ) )

            $option.attr('value', v).text( v );

            if( selected == v ) {
                $option.attr('selected', 'selected');
            }

            $option.appendTo( $select )
        })
    }

    return $select;
}

const sort = function()
{
    jQuery('[data-sort]').on('click', function(event) {

        event.preventDefault();

        let $sort = jQuery( this )
            ,order  = 'acs';

        courseCalendar.sort( 'course--start-date', { order: 'asc' } );

        if( $sort.is('.active') ) {

            if( $sort.is('.active--acs') ) {

                order = 'desc';

                $sort.removeClass( 'active--acs' )
                    .addClass( 'active--desc' );
            }else{

                $sort.removeClass( 'active-desc' )
                    .addClass( 'active--asc' );
            }

        }else{

            $sort.addClass( 'active' )
                .addClass( `active--${ order }` );
        }

        console.log($sort.data('sort'), { order: order });

        courseCalendar.sort( $sort.data('sort'), { order: order } );

    });
}


// WEBPACK FOOTER //
// ./src/Models/CourseCalendar/assets/index.js